import * as React from 'react';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import './reservationErrorPane.module.scss';

type Props = {
    message: string;
    onCompleteClick: () => any;
};

export class ReservationErrorPane extends React.Component<Props> {
    render() {
        const { message, onCompleteClick } = this.props;
        return (
            <div styleName="pane">
                <div styleName="text">予約に失敗しました</div>
                <div styleName="error">{message || '原因不明のエラー'}</div>
                <div styleName="button-wrapper">
                    <Button styleName="button" type="primary" size="m" disabled={false} onClick={onCompleteClick}>
                        戻る
                    </Button>
                </div>
            </div>
        );
    }
}
